// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"bb141a51","551":"29250199","842":"ca9f998e","851":"b8b870c7"}[chunkId] + ".chunk.js";
};